/* Hot Girls Care — theme.js */

// Sticky nav on scroll
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 60);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Mobile nav toggle
(function () {
  const toggle = document.querySelector('.site-header__menu-toggle');
  const mobileNav = document.querySelector('.site-header__mobile-nav');
  const closeBtn = document.querySelector('.mobile-nav-close');
  if (!toggle || !mobileNav) return;

  toggle.addEventListener('click', () => mobileNav.classList.add('open'));
  if (closeBtn) closeBtn.addEventListener('click', () => mobileNav.classList.remove('open'));

  mobileNav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => mobileNav.classList.remove('open'));
  });
})();

// Cart drawer (simple count update)
(function () {
  const cartCounts = document.querySelectorAll('[data-cart-count]');
  function updateCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cartCounts.forEach(el => { el.textContent = cart.item_count; });
      });
  }
  updateCart();

  document.addEventListener('cart:updated', updateCart);
})();

// Add to cart
(function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const btn = form.querySelector('.product-page__add');
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    const formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added!';
        document.dispatchEvent(new Event('cart:updated'));
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      });
  });
})();
